import React from "react";
import { Link } from "react-router-dom";
import { problems, ProblemArea } from "../data/problems";
import { Photo } from "../data/photography";
type ProblemListProps = {
  tone?: "light" | "dark";
  area?: Exclude<ProblemArea, "both">;
  title?: string;
  intro?: string;
  image?: Photo;
  imageCaption?: string;
  homeOnly?: boolean;
  closingCta?: boolean;
};
export function ProblemList({
  tone = "light",
  area,
  title = "When to call Constant.",
  intro = "Real situations, in plain terms. If one of these sounds familiar, we should talk.",
  image,
  imageCaption,
  homeOnly = false,
  closingCta = false
}: ProblemListProps) {
  const dark = tone === "dark";
  const items = problems.filter(p => (!area || p.area === area || p.area === "both") && (!homeOnly || p.onHome));
  return <section aria-labelledby="problems-title" className={dark ? "bg-navy text-ivory" : "border-t border-stone"} data-id="element-450" data-mp="3vc02n72wyiz8">
      <div className="shell py-24 md:py-32" data-id="element-451" data-mp="3z5f71vgwxbl">
        <div className="grid grid-cols-12 gap-x-6 gap-y-12" data-id="element-452" data-mp="ebi69xfgg8db">
          <div className="col-span-12 lg:col-span-4" data-id="element-453" data-mp="ec0777d2bark">
            <div className="lg:sticky lg:top-28" data-id="element-454" data-mp="9cxfeom3f11j">
              <p className={`eyebrow ${dark ? "text-ivory/75" : "text-oxblood"}`} data-id="element-455" data-mp="9e8h8ivz9yq0">When to call</p>
              <h2 id="problems-title" className={`mt-6 font-display text-[clamp(2.25rem,4vw,3.5rem)] leading-[1.05] ${dark ? "text-ivory" : "text-navy"}`} data-id="element-456" data-mp="o2mkuw17xr7m">
                {title}
              </h2>
              <p className={`mt-6 max-w-sm leading-relaxed ${dark ? "text-ivory/70" : "text-charcoal/75"}`} data-id="element-457" data-mp="s3etpo66hu3d">{intro}</p>
              <Link to="/contact" className={`mt-10 ${dark ? "inline-flex h-12 items-center bg-ivory px-7 text-[12px] font-semibold uppercase tracking-[0.18em] text-navy transition-colors duration-150 hover:bg-stone" : "btn-primary"}`} data-id="element-458" data-mp="16z4j7wakopcu">
                Talk to Us
              </Link>
              {image && <figure className="mt-14 hidden lg:block" data-id="element-459" data-mp="3tgl8hzjzanuu">
                  <div className="aspect-[4/5] max-w-sm overflow-hidden bg-stone" data-id="element-460" data-mp="3ti629mygy2rn">
                    <img src={image.src} alt={image.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-461" data-mp="1du6bi8xos93" />
                  </div>
                  {imageCaption && <figcaption className={`mt-4 max-w-sm font-display text-lg italic leading-snug ${dark ? "text-ivory/80" : "text-navy"}`} data-id="element-462" data-mp="bbi0a5yptvq7">
                      {imageCaption}
                    </figcaption>}
                </figure>}
            </div>
          </div>

          <ul className={`col-span-12 border-t lg:col-span-7 lg:col-start-6 ${dark ? "border-ivory/30" : "border-navy"}`} data-id="element-463" data-mp="p357v1y3yqoa">
            {items.map(p => <li key={p.text} className={`flex items-baseline justify-between gap-6 border-b py-5 md:py-6 ${dark ? "border-ivory/15" : "border-stone"}`} data-id="element-464" data-mp="z1caefrnh66r">
                <span className={`font-display text-xl leading-snug md:text-2xl ${dark ? "text-ivory" : "text-navy"}`} data-id="element-465" data-mp="2ohydjbx5mn4e">
                  {p.text}
                </span>
                <span className={`eyebrow shrink-0 ${dark ? "text-ivory/60" : "text-oxblood"}`} data-id="element-466" data-mp="2ejinzddrzlx0">{p.mode}</span>
              </li>)}
          </ul>
          {closingCta && <div className="col-span-12 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between lg:col-span-7 lg:col-start-6" data-id="element-467" data-mp="29ms74nu5cmaj">
              <p className={`font-display text-2xl italic ${dark ? "text-ivory" : "text-oxblood"}`} data-id="element-468" data-mp="328tem21evzxf">
                Recognize one of these? Let’s talk.
              </p>
              <Link to="/contact" className="btn-primary self-start sm:self-auto" data-id="element-469" data-mp="2sj9u6ry1vy0g">
                Talk to Us
              </Link>
            </div>}
        </div>
      </div>
    </section>;
}